// hooks/useColumnDefs.js - Updated to include master-detail column
import { useMemo } from "react";
import Flx from "../../../../../../components/layout/Flx";
import Txt from "../../../../../../components/typography/Txt";
import isArray from "lodash/isArray";
import Chip from "@mui/material/Chip";

export const useColumnDefsGlobalExceptionsTable = () => {
  return useMemo(
    () => [
      // This is the key column that creates the expand/collapse arrows
      {
        cellRenderer: "agGroupCellRenderer",
        filter: false,
        suppressHeaderFilterButton: true,
        width: 50,
        minWidth: 50,
        maxWidth: 50,
        flex: 0,
      },
      {
        field: "exception",
        cellRenderer: CellRendererException,
        // autoHeight: true,
        wrapText: true,
        cellStyle: { paddingTop: "16px", paddingBottom: "16px" },
      },
      { field: "status" },
      { field: "exception_type", headerName: "Exception Type" },
      {
        field: "internal_approval_granted_by",
        headerName: "Internal Approval Granted By",
      },
      { field: "createdAt", headerName: "Created At", type: "date" },
      {
        field: "compensating_factors",
        headerName: "Compensating Factors",
        cellRenderer: CellRendererChipList,
      },
    ],
    []
  );
};

const CellRendererException = (params) => {
  const { data } = params;
  return (
    <Flx column>
      <Txt bold>{data?.exception_type}</Txt>
      <Txt secondary>{data?.exception_description}</Txt>
      <Flx gap={0} sx={{ mt: 1.5 }}>
        <Chip
          color="warning"
          label={data?.situs_exception_severity}
          size="small"
          sx={{ mr: 1 }}
        />
        <Chip
          color="inherit"
          label={data?.approval_authority}
          size="small"
          sx={{ mr: 1 }}
        />
        <Chip
          color="inherit"
          label={data?.exception_category}
          size="small"
          sx={{ mr: 1 }}
        />
      </Flx>
    </Flx>
  );
};

const CellRendererChipList = (params) => {
  const { value } = params;
  if (!isArray(value)) {
    return null;
  }
  return value.map((item, index) => (
    <Chip
      key={index}
      color="inherit"
      label={item}
      size="small"
      sx={{ mr: 1 }}
      // variant="outlined"
      // variant="outlined"
    />
  ));
};
